import { render, staticRenderFns } from "./comp_WordpressPostItem.vue?vue&type=template&id=0900f966&scoped=true"
import script from "./comp_WordpressPostItem.vue?vue&type=script&lang=js"
export * from "./comp_WordpressPostItem.vue?vue&type=script&lang=js"
import style0 from "./comp_WordpressPostItem.vue?vue&type=style&index=0&id=0900f966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900f966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
